/* Silk Road Foods v3 — shared behaviour for sr3-* sections */
(function(){
  if (window.__sr3) return; window.__sr3 = true;
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Toast */
  var toastEl, tt;
  function toast(html){
    if (!toastEl){ toastEl = document.createElement('div'); toastEl.className = 'sr-toast'; toastEl.setAttribute('role','status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('on'); clearTimeout(tt);
    tt = setTimeout(function(){ toastEl.classList.remove('on'); }, 2600);
  }
  window.sr3Toast = toast;

  /* Mobile drawer */
  function closeDrawer(){ $$('.sr-drawer.on,.sr-scrim.on').forEach(function(e){ e.classList.remove('on'); }); document.documentElement.style.overflow=''; }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-sr-open-menu]')){ var d=$('.sr-drawer'), s=$('.sr-scrim'); if(d){ d.classList.add('on'); s && s.classList.add('on'); document.documentElement.style.overflow='hidden'; } }
    if (e.target.closest('[data-sr-close]') || e.target.classList.contains('sr-scrim')) closeDrawer();
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeDrawer(); });

  /* Rails */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-sr-rail]'); if (!b) return;
    var r = document.getElementById(b.getAttribute('data-sr-rail'));
    if (r) r.scrollBy({ left: (r.clientWidth / 2) * (+b.getAttribute('data-dir')), behavior: 'smooth' });
  });

  /* AJAX add to cart */
  function setCount(n){ $$('[data-sr-cart-count],[data-srp-cart-count]').forEach(function(el){ el.textContent = n; }); }
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-sr-add]'); if (!f) return;
    e.preventDefault();
    var btn = $('button', f); if (btn){ btn.disabled = true; }
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method:'POST', headers:{ 'Accept':'application/json' }, body:new FormData(f) })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
      .then(function(item){
        return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function(r){ return r.json(); }).then(function(c){
          setCount(c.item_count);
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail:{ product:item } }));
          toast('Added: ' + (item.product_title || 'item') + ' <a href="/cart">View cart</a>');
        });
      })
      .catch(function(err){ toast((err && err.description) ? err.description : 'Sorry, that item could not be added.'); })
      .then(function(){ if (btn){ btn.disabled = false; } });
  });

  /* Postal code checker */
  document.addEventListener('submit', function(e){
    var f = e.target.closest('form[data-sr-postal]'); if (!f) return;
    e.preventDefault();
    var input = $('input', f), out = f.parentNode.querySelector('.sr-result');
    var v = (input.value || '').replace(/\s/g,'').toUpperCase();
    var prefixes = (f.getAttribute('data-prefixes') || '').toUpperCase().split(',').map(function(s){ return s.trim(); }).filter(Boolean);
    if (!/^[A-Z]\d[A-Z]\d[A-Z]\d$/.test(v)){ out.className='sr-result no'; out.textContent = f.getAttribute('data-msg-invalid'); return; }
    var ok = prefixes.some(function(p){ return v.indexOf(p) === 0; });
    var pretty = v.slice(0,3) + ' ' + v.slice(3);
    out.className = 'sr-result ' + (ok ? 'ok' : 'no');
    out.textContent = (ok ? f.getAttribute('data-msg-yes') : f.getAttribute('data-msg-no')).replace('[postal]', pretty);
  });

  /* Store hours: window.SR3_HOURS = [[open,close] x 7], Sunday first, 24h decimal */
  function fmt(h){ var hh=Math.floor(h), mm=Math.round((h-hh)*60), ap=hh>=12?'pm':'am', h12=hh%12||12; return h12 + ':' + (mm<10?'0':'') + mm + ' ' + ap; }
  function hoursInit(){
    var H = window.SR3_HOURS; if (!H) return;
    var d = new Date(), day = d.getDay(), now = d.getHours() + d.getMinutes()/60, t = H[day] || [0,0];
    var open = now >= t[0] && now < t[1];
    var nextOpen = now < t[0] ? 'Opens today at ' + fmt(t[0]) : 'Opens tomorrow at ' + fmt((H[(day+1)%7]||[9])[0]);
    $$('[data-sr-open-text]').forEach(function(el){ el.textContent = open ? 'Open today until ' + fmt(t[1]) : nextOpen; });
    $$('[data-sr-open-dot]').forEach(function(el){ el.classList.toggle('closed', !open); });
    $$('[data-sr-open-pill]').forEach(function(el){ el.classList.toggle('closed', !open); el.innerHTML = '<i></i>' + (open ? 'Open now · until ' + fmt(t[1]) : nextOpen); });
    $$('[data-sr-days]').forEach(function(el){ if ((',' + el.getAttribute('data-sr-days') + ',').indexOf(',' + day + ',') > -1) el.classList.add('is-today'); });
  }
  /* Flyer countdown */
  function flyerInit(){
    $$('[data-sr-ends]').forEach(function(el){
      var end = new Date(el.getAttribute('data-sr-ends') + 'T23:59:59'); if (isNaN(end)) return;
      var days = Math.ceil((end - new Date()) / 864e5);
      el.textContent = days > 1 ? 'Deals end in ' + days + ' days' : days === 1 ? 'Deals end tomorrow' : days === 0 ? 'Last day for these deals' : 'New flyer coming soon';
    });
  }
  function init(){ hoursInit(); flyerInit(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
